import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTRSNode } from 'API/TRSNodes/updateTRSNode';

const useUpdateTRSNode = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const updateNodeMutation = async (nodeData) => {
        try {
            const response = await updateTRSNode(nodeData);
            return response.data;
        } catch (error) {
            console.error('Error updating TRS node:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: updateNodeMutation,
        onSuccess: (data, variables) => {
            // Invalidate and refetch the nodes list
            queryClient.invalidateQueries({ queryKey: ['TRSNodes'] });
            // Invalidate the specific node being edited
            queryClient.invalidateQueries({
                queryKey: ['TRSNode', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateTRSNode;
